// extracted by css-extract-rspack-plugin
export default {"navigationButton":"_JUEw9pWXxU1bWkj","navigationButtonFullPage":"LTH5IKL0Loswvi7g"};